import { t } from "i18next";
import {
  IWebsiteBuilderElementBase,
  IWebsiteBuilderElementDataBase,
  IWebsiteBuilderElementDesignStyles,
  TWebsiteBuilderElement,
} from "./websiteBuilderElement";

export interface IWebsiteBuilderParagraphSettings {
  text: string;
}

export interface IWebsiteBuilderParagraphData extends IWebsiteBuilderElementDataBase {
  type: "paragraph";
  settings: IWebsiteBuilderParagraphSettings;
}

export interface IWebsiteBuilderParagraph extends IWebsiteBuilderElementBase {
  element: IWebsiteBuilderParagraphData;
}

export function isWebsiteBuilderParagraph(node: TWebsiteBuilderElement): node is IWebsiteBuilderParagraph {
  return node?.element?.type === "paragraph";
}

export function generateDefaultParagraph(): IWebsiteBuilderParagraph {
  return {
    id: crypto.randomUUID(),
    type: "element",
    element: {
      type: "paragraph",
      position: { x: 0, y: 0 },
      dimensions: { width: 150, height: 35 },
      zIndex: null,
      settings: {
        text: t("Paragraph"),
      },
    },
  };
}

export function generateParagraphDesignStyles(
  settings: IWebsiteBuilderParagraphSettings,
): IWebsiteBuilderElementDesignStyles {
  return {
    className: "website-builder-paragraph",
    style: {},
  };
}
